// extracted by mini-css-extract-plugin
export default {"top-toolbar_edit-contact-page":"Contacts_top-toolbar_edit-contact-page__eb3Tb"};